import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import '../../../utils/index_orig/index.esm.js';
import '../../../utils/theme/theme-provider/index.esm.js';
import { useLocalization } from '@shared-ui/localization-context';
import { getWeekdayNames } from '../calendar-utils/intl/index.esm.js';
import styles from '../../../styles/uitk-egds-calendar.css';
import { classNames } from '../../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const WeekdayNames = ({
  dayNameLength,
  locale
}) => {
  const baseClass = 'uitk-weekday';
  const weekDayNameClasses = React.useMemo(() => getClassNameList(`${baseClass}-names`), []);
  const weekDayClasses = React.useMemo(() => getClassNameList(`${baseClass}-title`), []);
  const l10n = useLocalization();
  const longWeekdayNames = React.useMemo(() => getWeekdayNames(l10n, locale, 'long'), [l10n, locale]);
  const weekdayNames = React.useMemo(() => dayNameLength === 'long' ? longWeekdayNames : getWeekdayNames(l10n, locale, dayNameLength), [dayNameLength, l10n, locale, longWeekdayNames]);
  return jsx("tr", {
    className: weekDayNameClasses,
    children: weekdayNames.map((weekdayName, i) => jsxs("th", {
      scope: "col",
      className: weekDayClasses,
      children: [jsx("span", {
        "aria-hidden": "true",
        children: weekdayName
      }), jsx("span", {
        className: "is-visually-hidden",
        children: longWeekdayNames[i]
      })]
    }, `weekday-${i}`))
  });
};
WeekdayNames.displayName = 'WeekdayNames';
export { WeekdayNames as default };